import { classNamesFor } from '../../../utils/classNames';
import { choiceChipSizes } from './constants';

const factory = classNamesFor('ChoiceChip');

export const choiceChipClassNames = {
  root: factory.root(),
  label: factory.element('label'),
  ...factory.toAttrClasses('size', choiceChipSizes),
  selected: factory.attribute('selected'),
  disabled: factory.globalClassNames.disabled,
};
